export default __webpack_public_path__ + "static/media/nft-15.3695eb75.png";